<template src="../templates/normal_fcont_181.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import UseDesignPaperList from '../components/UseDesignPaperList'
import PrintButton from '../components/PrintButton'
import CreatorProfileItsuka from "../components/CreatorProfileItsuka"
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,
    UseDesignPaperList,PrintButton,
    CreatorProfileItsuka,InfoMachineTranslation
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['181-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['181-3']}
      ]
    };
  }
  
};
</script>
<style scoped>

</style>

